import React from "react";

const NoOpenJobs=()=>{
    return(
        <div id="no-open-jobs">
<h3>No Vacancies At The Moment</h3>
        </div>
    )
}
export default NoOpenJobs;